import { Field, formValueSelector, reduxForm } from 'redux-form';
import {
  isInteger,
  isValidNameWithSpace,
  renderCheckBox,
  renderColorPicker,
  renderTextArea,
  renderTextField,
  renderAutoCompleteSingleSelect,
  renderAutoCompleteScheduling,
  renderAutoCompleteMultipleSelection,
} from './../../../../components/reduxFields';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import React from 'react';
import { getAppointmentTypeDetail, saveAppointmentType } from './actions/AppointmentTypeActions';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../components/buttons';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError, SWANCONSULTINGINC, EBS, AIP, VIP, FUTURES} from '../../../../../src/actions/utilAction';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
  const errors = {};
  // console.log(values)
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Please enter appointment name';
  }
  // if (!values.Description) {
  //   errors.Description = 'Please enter description';
  // }
  if (!values.defaultDuration) {
    errors.defaultDuration = 'Please enter default time duration';
  }
  if (!values.color || values.color.trim() === '') {
    errors.color = 'Please select color';
  } else if (!/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(values.color)) {
    errors.color = 'Please select a hex code for color';
  }
  if (!values.fontColor || values.fontColor.trim() === '') {
    errors.fontColor = 'Please select font color';
  } else if (!/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(values.fontColor)) {
    errors.fontColor = 'Please select a hex code for font color';
  }
  if (!values.therapyId) {
    errors.therapyId = 'Please select therapy';
  }

  return errors;
};


// const validatePayRateTypeId = (PayRateTypeId) => {
//   if (!PayRateTypeId) {
//     return 'Please select pay rate type.';
//   } else if (!Number.isInteger(PayRateTypeId)) {
//     return 'Please select an option.';
//   }  
// };


/**
 * Dialog content can be scrollable.
 */
class AppointmentTypeModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      color: (props.appointmentTypeObj && props.appointmentTypeObj.color) || '#000000',
      fontColor: (props.appointmentTypeObj && props.appointmentTypeObj.fontColor) || '#ffffff',
      appointmentTypeUserRoles: [],
      appointmentDefaultSetting: [],
      appointmentTypesDefaultSettingModels: [],
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.onColorChange = this.onColorChange.bind(this);
    this.onFontColorChange = this.onFontColorChange.bind(this);
    //this.checkAppointmentType = this.checkAppointmentType.bind(this);
  }

  componentWillMount() {
    if (this.props.appointmentTypeId) {
      this.props.getAppointmentTypeDetail(this.props.appointmentTypeId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  
  handleNewMultiRequest(input, value) {
    input.onChange(value);    
  }  
  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleDefaultAppointmentSettings = (input, value) =>{
    let appointmentDefaultSettingList = this.props.appointmentDefaultSettingList;
    
    const directOption = appointmentDefaultSettingList.find(option => option.globalCodeName === "Direct");
    const indirectOption = appointmentDefaultSettingList.find(option => option.globalCodeName === "Indirect");

    const directOptionId = directOption ? directOption.id : null;
    const indirectOptionId = indirectOption ? indirectOption.id : null;


    if (value.includes(directOptionId) && value.includes(indirectOptionId)) {
        // If both Direct and Indirect are selected, remove the last selected one
        const lastSelected = value[value.length - 1];
        if (lastSelected === directOptionId) {
            value = value.filter(id => id !== indirectOptionId);
        } else {
            value = value.filter(id => id !== directOptionId);
        }
    }
    input.onChange(value);
  }
  // checkAppointmentType = (e, name) => {
  //   if (name === 'allowMultipleStaff' && e.target.checked) {
  //     this.props.dispatch(change('AppointmentTypeModalForm', 'isClientRequired', false));
  //     this.props.dispatch(change('AppointmentTypeModalForm', 'isBillable', false));
  //   } else if ((name === 'isBillable' || name === 'isClientRequired') && e.target.checked) {
  //     this.props.dispatch(change('AppointmentTypeModalForm', 'allowMultipleStaff', false));
  //   }
  // }
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

    if (nextProps.appointmentTypeDetail && nextProps.appointmentTypeDetail !== this.props.appointmentTypeDetail) {
      let aptTypeData = nextProps.appointmentTypeDetail.data;      
      let appointmentTypeUserRoles = aptTypeData.appointmentTypeUserRoles || []; 
      let appointmentTypesDefaultSettingModels = aptTypeData.appointmentTypesDefaultSettingModels || [];     
      this.setState({ appointmentTypeUserRoles: appointmentTypeUserRoles,appointmentTypesDefaultSettingModels: appointmentTypesDefaultSettingModels});
    }
    if (nextProps.appointmentDefaultSettingList) {
      let data = nextProps.appointmentDefaultSettingList;      
      this.setState({ appointmentDefaultSetting: data});
    }
  }
  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      // console.log('labelName.........',labelName)
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.props.appointmentTypeId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }
    formProps['name'] = formProps.name.trim();
    formProps['description'] = formProps.description ? formProps.description.trim() : '';
    formProps['allowMultipleStaff'] = formProps.allowMultipleStaff ? true : false;
    formProps['isClientRequired'] = formProps.isClientRequired ? true : false;
    formProps['isIncludeInRBTSupervisionReport'] = formProps.isIncludeInRBTSupervisionReport ? true : false;   
    formProps['isAllowOverlapping'] = formProps.isAllowOverlapping ? true : false;          
    formProps['hiddenFromParentPortal'] = formProps.hiddenFromParentPortal ? true : false;       
    formProps['isPaidHourly'] = formProps.isPaidHourly ? true : false;       

    let appointmentTypeUserRoles = [];
    let appointmentTypesDefaultSettingModels = [];
    if (formProps.userRoles) {
      appointmentTypeUserRoles = (this.state.appointmentTypeUserRoles || []).map((Obj) => {
        return { ...Obj, isDeleted: true };
      });

      (formProps.userRoles || []).forEach((roleId) => {
        // update case for userRoles ------
        let userRoles = appointmentTypeUserRoles.find((Obj) => Obj.roleId === roleId && Obj.isDeleted);
        if (userRoles) {
          let index = appointmentTypeUserRoles.indexOf(userRoles);
          appointmentTypeUserRoles[index] = {
            ...userRoles,
            'isDeleted': false,
          };
        } else {
          appointmentTypeUserRoles.push({
            'id': 0,
            'appointmentTypeId': this.props.appointmentTypeId || 0,
            'roleId': roleId,
            'isDeleted': false,
          });
        }
      });
   
      appointmentTypeUserRoles = appointmentTypeUserRoles.filter((obj) => obj.isDeleted === false);
      //console.log('appointmentTypeUserRoles........',appointmentTypeUserRoles);
    }

    if(formProps.appointmentTypesDefaultSettingModels){    
      (formProps.appointmentTypesDefaultSettingModels || []).forEach((obj) => {
        let globalCode  = this.state.appointmentDefaultSetting.find((Obj) => Obj.id === obj)
       let appId = this.state.appointmentTypesDefaultSettingModels.find((Obj) => Obj.globalCodeId === obj) || {}
       appointmentTypesDefaultSettingModels.push({
          'Id' : appId.id || 0,
          'setting_type':globalCode ? globalCode.globalCodeName : '',
          'GlobalCodeId':globalCode ? globalCode.id : 0,
        })
      });
    }
    
    let postData = {
      ...formProps,
      'id': this.props.appointmentTypeId || 0,   
      'appointmentTypeUserRoles': appointmentTypeUserRoles,
      'appointmentTypesDefaultSettingModels':appointmentTypesDefaultSettingModels,
    };

    //console.log(postData);
    this.props.clearFieldErrorArray();
    this.props.saveAppointmentType(postData);
    this.props.closeDialog();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }
  onColorChange(color){    
    this.setState({ color: color[0]+color[1]+color[2]+color[3]+color[4]+color[5]+color[6] });
  }

  onFontColorChange(color){
    this.setState({ fontColor: color[0]+color[1]+color[2]+color[3]+color[4]+color[5]+color[6] });
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.props.appointmentTypeId ? 'Edit Appointment Type' : 'Add Appointment Type'}
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form">
                <div className="row">
                  <div className='col-sm-6 require'>
                    <Field
                      autoFocus={true}
                      name="name"
                      type="text"
                      maxLength="100"
                      onBlur={(input, value) => this.checkFieldDataExistence(input, value, 'Appointment name')}
                      customError={displayCustomError('NAME', this.props.fieldError)}
                      floatingLabelText="Appointment Name"
                      normalize={isValidNameWithSpace}
                      component={renderTextField}
                      fullWidth={true}
                    />
                  </div>
                  <div className='col-sm-6 require'>
                    <Field
                      name="defaultDuration"
                      type="text"
                      floatingLabelText="Default Duration (min)"
                      component={renderTextField}
                      fullWidth={true}
                      maxLength="3"
                      normalize={isInteger}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className="col-sm-6 require">
                    <Field
                      name="color"
                      defaultValue={this.state.color}
                      floatingLabelText="Color"
                      fullWidth={true}
                      onChange={(color) => this.onColorChange(color)}
                      component={renderColorPicker} />
                      <span className="bgcolor-circle" style={{ backgroundColor: this.state.color }}></span>
                  </div>
                  <div className="col-sm-6 require">
                    <Field
                      name="fontColor"
                      defaultValue={this.state.fontColor}
                      floatingLabelText="Font Color"
                      fullWidth={true}
                      onChange={(fontColor) => this.onFontColorChange(fontColor)}
                      component={renderColorPicker} />
                      <span className="bgcolor-circle" style={{ backgroundColor: this.state.fontColor }}></span>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-6 require mt-30'>
                    <Field
                      name="therapyId"
                      label="Select Therapy"
                      options={this.props.masterTherapy}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>                  
                  <div className='col-sm-6 mt-30'>
                    <Field
                      name="noteTypeId"
                      label="Select Session Note"
                      options={this.props.masterNoteType}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect}
                    />
                    <small className="redfont font12">Please note: The session note selected here will only apply if this appointment type is marked billable.</small>
                  </div>                
                </div>
                {(this.props.agencyName.toUpperCase().startsWith(EBS) || this.props.agencyName.toUpperCase() === AIP  || this.props.agencyName.toUpperCase() === 'FUTURES' || this.props.agencyName.toUpperCase() === 'ACT' || this.props.agencyName.toUpperCase() === VIP) ?     
                   <div className='row'>        
                    <div className="col-sm-6 mt-40">
                      <Field
                        name="payRateTypeId"
                        label="Pay Rate Type"
                        options={this.props.payRateTypeId}                        
                        handleNewRequest={this.handleNewRequest}
                        //validate={validatePayRateTypeId}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className='col-sm-6 mt-30'></div>
                  </div>
                :null}       
                 <div className='row'>        
                    <div className="col-sm-6 mt-40">
                     <small className="greyfont font12">Only allow the following roles to view this appointment type: </small>
                      <Field
                        name="userRoles"
                        label="User Roles"
                        handleNewRequest={this.handleNewMultiRequest}
                        options={this.props.userRoleList}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                      <small className="redfont font12">Leave this blank if you would like all staff to have access to this appointment type </small>
                    </div>
                  </div> 
                <div className="row">
                  <div className="col-sm-12">
                    <Field
                      name="description"
                      type="text"
                      label="Description"
                      component={renderTextArea}
                      // normalize ={isValidNameWithSpace}
                      fullWidth={true}
                      maxLength="1000"
                    />
                    <small className="blackfont font12">{this.props.description ? 1000 - this.props.description.length : 1000} Characters Remaining </small>
                  </div>
                </div>
                <div className="row mt-30">
                  <div className="col-sm-6">
                    <Field
                      name="appointmentTypesDefaultSettingModels"
                      label="Set Default Appointment Settings"
                      handleNewRequest={this.handleDefaultAppointmentSettings}
                      options={this.props.appointmentDefaultSettingList}
                      component={renderAutoCompleteMultipleSelection}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="isBillable"
                      label="Billable"
                      component={renderCheckBox}
                      value={true}
                      //onChange={(e) => this.checkAppointmentType(e, 'isBillable')}
                    />        
                  </div>
                  <div className="col-sm-6 mt-20 custm_appointmenttype">
                    <span>(If billable is selected, client-required should also be selected.)</span>           
                  </div>
                </div>
                {/* <div className="row">
                  <div className="col-sm-4">
                    <Field className="custm_check"
                      name="allowMultipleStaff"
                      label="Allow Multiple Staff"
                      component={renderCheckBox}
                      //onChange={(e) => this.checkAppointmentType(e, 'allowMultipleStaff')}

                    />
                  </div>
                  <div className="col-sm-8">
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-sm-4">
                    <Field className="custm_check"
                      name="isClientRequired"
                      label="Client Required"
                      component={renderCheckBox}
                      //onChange={(e) => this.checkAppointmentType(e, 'isClientRequired')}
                    />
                  </div>
                  <div className="col-sm-8">
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field className="custm_check"
                      name="isIncludeInRBTSupervisionReport"
                      label="Include In RBT Supervision Report"
                      component={renderCheckBox}
                    />
                  </div>                
                  <div className="col-sm-6 custm_appointmenttype">
                    <span>(Select if an RBT will be rendering this service.)</span>           
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <Field className="custm_check"
                      name="isAllowOverlapping"
                      label="Allow Overlapping"
                      component={renderCheckBox}
                    />
                  </div>                  
                  {/* <div className="col-sm-6 custm_appointmenttype">
                    <span>(Used for group services such as 97154.)</span>           
                  </div> */}
                </div>     
                <div className="row">
                  <div className="col-sm-12 custm_appointmenttype">
                    <span>Allowing overlap will allow user(s) to schedule the same appointment type with the same or different client at the same time. This is useful for group services or appointments with more than 1 staff working with one client at the same time.</span>
                  </div>                  
                </div>
                {this.props.agencyName.toUpperCase() === SWANCONSULTINGINC ?           
                  <div className="row">
                    <div className="col-sm-8">
                      <Field className="custm_check"
                        name="hiddenFromParentPortal"
                        label="Hide From Parent Portal"
                        component={renderCheckBox}
                      />
                    </div>
                    <div className="col-sm-4">
                    </div>
                  </div>   
                : null} 
                {this.props.agencyName.toUpperCase() === FUTURES || this.props.agencyName.toUpperCase() === VIP ?           
                <div className="row">
                  <div className="col-sm-8">
                    <Field className="custm_check"
                      name="isPaidHourly"
                      label="Paid Hourly"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-4">
                  </div>
                </div> 
                : null}  
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

const selector = formValueSelector('AppointmentTypeModalForm');
const mapStateToProps = (state, ownProps) => {
  let initialValueData = {
    color: (ownProps.appointmentTypeObj && ownProps.appointmentTypeObj.color) || '#000000',
    fontColor: (ownProps.appointmentTypeObj && ownProps.appointmentTypeObj.fontColor) || '#ffffff',
  };
  if (ownProps.appointmentTypeId && state.appointment_type.appointmentTypeDetail) {
    let appointmentTypeData = state.appointment_type.appointmentTypeDetail.data;
   
    let appointmentTypeUserRoles = (appointmentTypeData.appointmentTypeUserRoles || []).map((obj) => obj.roleId);
    let appointmentTypesDefaultSettingModels = (appointmentTypeData.appointmentTypesDefaultSettingModels || []).map((obj) => obj.globalCodeId);
    initialValueData = {
      ...appointmentTypeData,
      userRoles: appointmentTypeUserRoles,
      appointmentTypesDefaultSettingModels :appointmentTypesDefaultSettingModels
    };
  }
  //console.log('initialValueData...........',initialValueData)
  return {
    color: selector(state, 'color'),
    fontColor: selector(state, 'fontColor'),
    description: selector(state, 'description'),
    userRoles: selector(state, 'userRoles'),
    appointmentTypesDefaultSettingModels: selector(state, 'appointmentTypesDefaultSettingModels'),
    initialValues: initialValueData,
    appointmentTypeDetail: state.appointment_type.appointmentTypeDetail,
    loading: state.appointment_type.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    masterTherapy: state.appointment_type.master_Data && state.appointment_type.master_Data.masterTherapy,
    masterNoteType: state.appointment_type.master_Data && state.appointment_type.master_Data.masterNoteType,
    payRateTypeId: state.appointment_type.master_Data && state.appointment_type.master_Data.payRateType,
    userRoleList: state.appointment_type.master_Data && state.appointment_type.master_Data.masterRoles,
    appointmentDefaultSettingList: state.appointment_type.master_Data && state.appointment_type.master_Data.masterAppointmentTypeDefaultSetting,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
};

AppointmentTypeModal = reduxForm({
  form: 'AppointmentTypeModalForm', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(AppointmentTypeModal);

export default connect(mapStateToProps, { saveAppointmentType, getAppointmentTypeDetail, clearFieldErrorArray, checkFieldExistence })(AppointmentTypeModal);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/appointment-type/appointment_type_modal.js